<!-- Loader -->
<div *ngIf="isLoading" class="spinner-container">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Chargement...</span>
  </div>
</div>

<div *ngIf="!isLoading">
  <div class="container">
  <div class="main-body">
    <div class="row equal-height">
      <!-- Profile Card -->
      <div class="col-lg-4">
        <div class="card card-profile">
          <div class="card-body">
            <div class="d-flex flex-column align-items-center text-center">
              <div class="avatar-circle">
                {{ (client.firstName?.charAt(0) || '') + (client.lastName?.charAt(0) || '') }}
              </div>
              <div class="mt-3">
                <h4>{{ client.lastName }} {{ client.firstName }}</h4>
                <p class="text-secondary mb-1">{{ client.phoneNumber }}</p>
                <button class="btn btn-outline-primary">Message</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit Form -->
      <div class="col-lg-8">
        <div class="card card-form">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-sm-3">
                <h6 class="mb-0">Prénom</h6>
              </div>
              <div class="col-sm-9 text-secondary">
                <input type="text" class="form-control" [(ngModel)]="client.firstName" name="firstName">
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-sm-3">
                <h6 class="mb-0">Nom</h6>
              </div>
              <div class="col-sm-9 text-secondary">
                <input type="text" class="form-control" [(ngModel)]="client.lastName" name="lastName">
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-sm-3">
               <h6 class="mb-0">Email</h6>
              </div>
              <div class="col-sm-9 text-secondary">
                <input type="email" class="form-control" [(ngModel)]="client.email" name="email">
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-sm-3">
                <h6 class="mb-0">Téléphone</h6>
              </div>
              <div class="col-sm-9 text-secondary">
                <input type="text" class="form-control" [(ngModel)]="client.phoneNumber" name="phoneNumber">
              </div>
            </div>

            <div class="row">
              <div class="col-sm-3"></div>
              <div class="col-sm-9 text-secondary">
                <input type="button" class="btn btn-primary gradient-primary px-4" (click)="updateClient()" value="Enregistrer les modifications">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-client-order-list [clientId]="client.id!"></app-client-order-list>
</div>


